import React from 'react'
import HeroSection from './HeroSection'
import GlobalSection from './GlobalSection'
import FeaturesSection from './FeaturesSection'
import HowItWorksSection from './HowItWorksSection'
import PricingSection from './PricingSection'
import ContactSection from './ContactSection'

const Landing: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <GlobalSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection />
      <ContactSection />
    </div>
  )
}

export default Landing
